import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Components from "./CompMap";
import { Tabs, Tab, TabList, TabPanel } from "react-web-tabs";
import { withStyles } from "@material-ui/styles";
import { FormStore } from "../../services/form.store";
import { CLOSE_POPUP } from "../../constants/Constants";
import AlertDialog from "./AlertDialog";
import { ALERT_DIALOGS } from "../../services/form.helper.service";
import FormBuilderService from "../../services/form-builder.service";
import FormNameControl from "../../shared/component/FormNameControl";

const styles = (theme) => ({
  dialogPaper: {
    height: "700px",
  },
});

class FormPopup extends Component {
  constructor(props) {
    super();
    this.formBuilderService = new FormBuilderService();
    this.state = {
      formTabName: props.selectedLanguage,
      languageAlert: false,
      translatedTitle: props?.translatedForm?.title,
      translatedCode: props?.translatedForm?.translationToCode,
      formTitle: `${props?.form?.title} - ${props?.form?.translationToCode?.toUpperCase()}`,
      disableActionBtn: false,
    };
  }

  setFormTitle = (value) => {
    this.setState({ formTitle: value });
  };

  setDisableActionBtn = (flag) => {
    this.setState({ disableActionBtn: flag });
  };

  requiredFieldValidator(value) {
    return value && value.length > 0 ? true : false;
  }

  minLengthValidator(value, minLength) {
    if (value !== "") {
      return value.trim().length >= minLength ? true : false;
    } else {
      return true;
    }
  }

  maxLengthValidator(value, maxLength) {
    if (value !== "") {
      return value.length <= maxLength ? true : false;
    } else {
      return true;
    }
  }

  alphanumericValidator(value) {
    if (value !== "") {
      const pattern = /^[a-zA-Z0-9\s!"#$%&'()*+,\-./:;<=>?@[\\\]^_`{|}~]*$/; // Allow spaces and common special characters
      return pattern.test(value.trim());
    } else {
      return true;
    }
  }

  getHelperTextForName(value) {
    let helperText = "";
    if (!this.requiredFieldValidator(value)) {
      helperText = "Form Name is required!";
    } else if (!this.minLengthValidator(value, 3)) {
      helperText = "Form Name should have a minimum of 3 characters.";
    } else if (!this.maxLengthValidator(value, 500)) {
      helperText = "Form Name should not exceed 500 characters.";
    } else if (!this.alphanumericValidator(value)) {
      helperText = "Form Name should be alphanumeric.";
    }
    return helperText;
  }

  handleSelect = (event) => {
    this.setState({
      formTabName: event,
    });
  };

  saveTranslateForm = () => {
    FormStore.sharedInstance().populateTranslatedFormTitle(
      this.state.formTitle,
    );
    FormStore.sharedInstance().saveTranslateForm();
    this.props.onClose(CLOSE_POPUP);
    this.setState({ languageAlert: false });
  };

  render() {
    const { classes } = this.props;
    const { formTitle } = this.state;
    const helperText = this.getHelperTextForName(formTitle);
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.props.onClose}
          fullWidth="true"
          classes={{ paper: classes.dialogPaper }}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <Tabs
              defaultTab={this.state.formTabName}
              horizontal="true"
              style={{ background: "#fcfcfc" }}
              onChange={(event) => this.handleSelect(event)}
            >
              <TabList>
                <FormNameControl
                  formTitle={this.state.formTitle}
                  setFormTitle={this.setFormTitle}
                  helperText={helperText}
                  error={!!helperText}
                  setDisableActionBtn={this.setDisableActionBtn}
                />
                <Tab
                  tabFor={this.props.selectedLanguage}
                  key={1}
                  style={{ textTransform: "uppercase" }}
                >
                  {this.props.selectedLanguage}
                </Tab>
                <Tab
                  tabFor={this.props.defaultTabName}
                  key={2}
                  style={{ textTransform: "uppercase" }}
                >
                  {this.props.defaultTabName}
                </Tab>
              </TabList>

              <TabPanel
                tabId={this.props.selectedLanguage}
                style={{ width: "100%" }}
              >
                <RenderListInternal
                  id="renderListInternal"
                  translatedForm={this.props.translatedForm}
                />
              </TabPanel>

              <TabPanel
                tabId={this.props.defaultTabName}
                style={{ width: "100%" }}
              >
                <RenderListInternalPopup
                  id="renderListInternalPopup"
                  form={this.props.form}
                />
              </TabPanel>
            </Tabs>
          </DialogContent>
          {this.state.formTabName === this.props.selectedLanguage ? (
            <DialogActions>
              <Button
                onClick={this.props.onClose}
                variant="outlined"
                color="inherit"
                id="cancel"
              >
                Cancel
              </Button>
              <Button
                onClick={() => this.setState({ languageAlert: true })}
                variant="contained"
                disabled={this.state.disableActionBtn}
              >
                TRANSLATE
              </Button>
            </DialogActions>
          ) : null}
          {this.state.languageAlert && (
            <AlertDialog
              open={this.state.languageAlert}
              onClose={() => this.setState({ languageAlert: false })}
              handleOk={() => this.saveTranslateForm()}
              dialogContent={ALERT_DIALOGS.TRANSLATION_CONTENT(
                this.props.selectedLanguage,
              )}
              confirmButton={ALERT_DIALOGS.TRANSLATION_CONTINUE}
              cancelButton={ALERT_DIALOGS.TRANSLATION_CANCEL}
              contentTextColor="black"
              successVariant
            />
          )}
        </Dialog>
      </div>
    );
  }
}

function RenderListInternal(props) {
  if (props.translatedForm !== undefined) {
    const TagName = Components["section"];
    const items = props.translatedForm.children.map((item, key) => (
      <TagName sectionPopup={item} key={item.id} />
    ));
    return items;
  }
  return <div> Empty Form </div>;
}

function RenderListInternalPopup(props) {
  if (props.form !== undefined) {
    const TagName = Components["section"];
    const items = props.form.children.map((item, key) => (
      <TagName sectionPopup={item} key={item.id} />
    ));
    return items;
  }
  return <div> Empty Form </div>;
}

export default withStyles(styles, { withTheme: true })(FormPopup);
